import { useAppData } from '@modules/_shared/providers/AppDataProvider';
import { isViewerOrLedUser } from '@modules/_shared/utils/isViewerOrLedUser';

export const useCanViewSubscriptions = (userId: string): boolean => {
  const { me } = useAppData();
  return (
    (me?.is_admin ?? false) ||
    isViewerOrLedUser(me?.id, me?.user_ids_in_led_teams, userId)
  );
};
